export const THUMBNAIL_WIDTH = 256;
export const THUMBNAIL_GAP = 24;
export const THUMBNAIL_WITH_GAP = THUMBNAIL_WIDTH + THUMBNAIL_GAP;
export const MOBILE_THUMBNAIL_WIDTH = 280;
export const MOBILE_GAP = 16;

export const SCROLL_TOLERANCE = 10;
export const SCROLL_DIFFERENCE_THRESHOLD = 20;
export const LOADING_DELAY = 500;
export const SCROLL_DEBOUNCE_DELAY = 1;

export const SWIPE_THRESHOLD = 50;
